import { metaTagString } from '../../utilities/meta_tags_util';

export default (urlPath, language, query, params) => {
  let metaData = '';

  switch (language) {
    case 'zh-cn': {
      metaData += metaTagString({
        urlPath,
        title: '关于我们',
        description:
          'Funliday 从 2017 创立以来，致力于解决旅人在旅游前、中、后所面临的种种问题。',
        language,
        noindex: true,
      });

      break;
    }
    case 'zh-tw': {
      metaData += metaTagString({
        urlPath,
        title: '關於我們',
        description:
          'Funliday 從 2017 創立以來，致力於解決旅人在旅遊前、中、後所面臨的種種問題。',
        language,
        noindex: true,
      });

      break;
    }
    case 'ja': {
      metaData += metaTagString({
        urlPath,
        title: '会社概要',
        description:
          'Funlidayは2017年の創立以来、旅行者が旅マエ、旅ナカ、旅アトで出くわす様々な問題を解決するために尽力して参りました。',
        language,
        noindex: true,
      });

      break;
    }
    case 'ko': {
      metaData += metaTagString({
        urlPath,
        title: '회사개요',
        description:
          'Funliday는 2017년의 창립 이래, 여행자가 여행전에, 여행 중에, 여행후에서 마주치는 여러가지 문제를 해결하기 위해서 노력해 왔습니다.',
        language,
        noindex: true,
      });

      break;
    }
    default: {
      metaData += metaTagString({
        urlPath,
        title: 'About Us',
        description:
          'Funliday helps you find the next destination and organize your trip easily.',
        language,
        noindex: true,
      });

      break;
    }
  }

  return {
    metaData,
  };
};
